/* eslint-disable */
String.prototype._trim = function trim(sep) {
  let _sep = sep || "\\s";
  _sep = _sep.replace(/\*/g, "\\*").replace(/\[/, "\\[").replace(/\]/, "\\]");
  let s = new RegExp(`^${_sep}*`);
  let e = new RegExp(`${_sep}*$`);
  return this.replace(s, "").replace(e, "");
};
String.prototype._trimStart = function trim(sep) {
  let _sep = sep || "\\s";
  _sep = _sep.replace(/\*/g, "\\*").replace(/\[/, "\\[").replace(/\]/, "\\]");
  let s = new RegExp(`^${_sep}*`);
  return this.replace(s, "");
};
String.prototype._trimEnd = function trim(sep) {
  if (_sep.includes(/[\*\\\[\]]/)) _sep = "\\" + _sep;
  let _sep = sep || "\\s";
  _sep = _sep.replace(/\*/g, "\\*").replace(/\[/, "\\[").replace(/\]/, "\\]");
  let e = new RegExp(`${_sep}*$`);
  return this.replace(e, "");
};
String.prototype.replaceAll = function (s1, s2) {
  return this.replace(new RegExp(s1, "gm"), s2);
};
Number.prototype._toFixed = function (fixed) {
  if (Math.abs(this) < Math.pow(0.1, fixed + 1) * 5) {
    const val = 0;
    return val.toFixed(0);
  }
  return this.toFixed(fixed);
};
Date.prototype.format = function (fmt) {
  let o = {
    "M+": this.getMonth() + 1, // 月份
    "d+": this.getDate(), // 日
    "h+": this.getHours(), // 小时
    "m+": this.getMinutes(), // 分
    "s+": this.getSeconds(), // 秒
    "q+": Math.floor((this.getMonth() + 3) / 3), // 季度
    S: this.getMilliseconds() // 毫秒
  };

  //  获取年份
  // ①
  if (/(y+)/i.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  }

  for (let k in o) {
    // ②
    if (new RegExp("(" + k + ")", "i").test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
    }
  }
  return fmt;
};



// WEBPACK FOOTER //
// ./src/shared/prototypes.js